import { BaseLoginProvider } from '@/helpers/entities/classes/providers/BaseLoginProvider';
export class FacebookLoginProvider extends BaseLoginProvider {
    constructor(clientId = process.env.VUE_APP_FB_APP_ID, locale = 'en_US', version = 'v13.0') {
        super();
        this.clientId = clientId;
        this.locale = locale;
        this.version = version;
    }
    initialize() {
        return new Promise((resolve) => {
            this.loadScript(FacebookLoginProvider.PROVIDER_ID, `//connect.facebook.net/${this.locale}/sdk.js`, () => {
                FB.init({
                    appId: this.clientId,
                    autoLogAppEvents: true,
                    cookie: true,
                    xfbml: true,
                    version: this.version,
                });
                resolve();
            });
        });
    }
    signIn(basicPermissions = false) {
        return new Promise((resolve) => {
            FB.login((response) => {
                resolve(response);
            }, {
                scope: this.permissionScopes(basicPermissions),
            });
            if (process.env.NODE_ENV === 'development') {
                console.log('Error: The method FB.login can no longer be called from http pages.\nExists only in local environment since we are not using HTTPS.');
            }
        });
    }
    permissionScopes(basicPermissions) {
        if (basicPermissions) {
            return FacebookLoginProvider.PROFILE_SCOPES;
        }
        return this.allPermissions;
    }
    get allPermissions() {
        const scopes = `${FacebookLoginProvider.PROFILE_SCOPES},${FacebookLoginProvider.PAGE_MANAGEMENT_SCOPES}`;
        // Temporarily Disable Business Management in Production
        // if (process.env.VUE_APP_FB_APP_ID === '2366423373588656') {
        //   return scopes;
        // }
        return `${scopes},${FacebookLoginProvider.INSTAGRAM_RELATED_SCOPES}`;
        // return `${scopes},${FacebookLoginProvider.FB_SHOP_RELATED_SCOPES}`;
    }
    get providerUrl() {
        return (`//connect.facebook.net/${this.locale}/sdk.js#version=${this.version}&` +
            `appId=${this.clientId}&xfbml=true&autoLogAppEvents=true&cookie=true`);
    }
}
FacebookLoginProvider.PROVIDER_ID = 'FACEBOOK';
FacebookLoginProvider.PROFILE_SCOPES = 'email, public_profile';
FacebookLoginProvider.PAGE_MANAGEMENT_SCOPES = 'ads_management,pages_manage_metadata,pages_messaging,pages_messaging_subscriptions,pages_show_list,pages_read_engagement,pages_manage_posts,business_management,pages_manage_engagement,catalog_management,ads_read';
// public static readonly FB_SHOP_RELATED_SCOPES = 'business_management,catalog_management';
FacebookLoginProvider.FB_SHOP_RELATED_SCOPES = 'catalog_management';
FacebookLoginProvider.INSTAGRAM_RELATED_SCOPES = 'instagram_manage_messages,instagram_basic';
